import { FETCH_GOALS_BY_WORKSPACE } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_GOALS_BY_WORKSPACE:
      return {
        ...state,
        list: action.payload
      }
    default:
      return state;
  }
};